import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const AuthorBoxNotesLoadable = loadable(() => import('./AuthorBoxNotes'), {
  resolveComponent: components => components.AuthorBoxNotes
});

export const AuthorBoxNotes = WithLazyHydration(AuthorBoxNotesLoadable, {
  name: 'AuthorBoxNotes'
});
